import styled from '@emotion/styled';

import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';

import { BreakPointToken } from '../../hooks/useMediaQuery';

import { StyledScrollbars } from '../../lib/utils/mixins';

const {
	spacing: {
		size_2px: { height: size_2 },
		size_4px: { height: size_4 },
		size_16px: { height: size_16 },
		size_40px: { height: size_40 },
		size_160px: { height: size_160 }
	},
	color: colours
} = tokens;

export const ListField = styled.div`
	position: relative;
`;

export const ListFieldList = styled.div`
	overflow: auto;
	max-height: ${size_40}vh;
	margin: 0 ${size_2 + size_4}px 0 0;
	@media (min-width: ${BreakPointToken.MdMin}px) {
		min-width: ${size_160 + size_40 + size_160 + size_16}px;
	}

	${StyledScrollbars};
`;

export const ListFieldError = styled.div`
	display: flex;
	align-items: flex-start;
	color: ${colours.light.text_error};

	& span {
		margin-inline-end: ${size_4}px;
	}
`;
